export const handleEnterPress = (e, callback) => {
    const isEnter = e.key === "Enter";
    if (isEnter) {
        callback();
    }
};
